<div class="layout-sidebar">
  <h1 class="sr-only" i18n="sr-only@@marketplace.search.title">Suche</h1>
  <aside class="sidebar">
    <app-search-mask (saveQuery)="saveQuery()" [isSaving]="isSaving$ | async" [parentGroup]="form"
    [unsavedQuery]="unsavedQuery"></app-search-mask>
  </aside>
  <main class="plain-content">
    @if ((search.isLoading$ | async) && (search.isMoreLoading$ | async) === false) {
      <div class="spinner-container">
        <app-spinner></app-spinner>
      </div>
    }
    <app-hitlist
      (loadMore)="loadMore()"
      (saveQuery)="saveQuery()"
      [hidden]="(search.isLoading$ | async) && (search.isMoreLoading$ | async) === false"
      [hitlist]="hitlist"
      [isSaving]="isSaving$ | async"
      [parentGroup]="form"
    [unsavedQuery]="unsavedQuery"></app-hitlist>
  </main>
</div>
